/* tslint:disable */
/* eslint-disable */
/**
 * Conversation Intelligence User API
 * Conversation Intelligence User API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: convitlall@microsoft.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ViewAsToConfigureFromJSON, ViewAsToConfigureToJSON, } from './ViewAsToConfigure';
/**
 * Check if a given object implements the UpdateAllOrgViewAsRequest interface.
 */
export function instanceOfUpdateAllOrgViewAsRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "configuredViewAs" in value;
    return isInstance;
}
export function UpdateAllOrgViewAsRequestFromJSON(json) {
    return UpdateAllOrgViewAsRequestFromJSONTyped(json, false);
}
export function UpdateAllOrgViewAsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'configuredViewAs': (json['configuredViewAs'].map(ViewAsToConfigureFromJSON)),
    };
}
export function UpdateAllOrgViewAsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'configuredViewAs': (value.configuredViewAs.map(ViewAsToConfigureToJSON)),
    };
}
